import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './GainersAndLosers.css';
import Pagination from '../../CommonUI/Pagination/Pagination';
import { useLocalStorage } from "../../utils/useLocalStorage";
import MarketEquity from "../MarketEquity";
import { Vortex } from 'react-loader-spinner'
import CallTrackApi from "../../Activity_Track/CallTrackApi";

function GainerLoser() {
    let optionInfoMarket = "Gainers & Losers";
    const [data, setData] = useState([]);
    const [valuebtn, setValueBtn] = useState("G");
    let optionTypeComp = "Daily Market Tracker";
    const [valueLi, setValueLi] = useState("Day");
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [groupValue, setGroupValue] = useState("BSE");
    const [groupIndex, setGroupIndex] = useState("BSE_SENSEX");
    const [groupIndexNSE, setGroupIndexNSE] = useState("NIFTY");
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;

    useEffect(() => {
        window.scrollTo(0, 0)
        setTimeout(() => {
            eleBtn.classList.add('active');
            eleLi.classList.add('active');
        })
    }, [])
    useEffect(() => {
        setloadingshow(true)
        if (groupValue === "BSE") {
            const getUrl = BaseURL + "GainersAndLosers";
            fetch(`${getUrl}/${groupValue}/${groupIndex}/${valueLi}/${valuebtn}/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false)
                    //  console.log(getData, "getData")
                })
                .catch((error) => {
                });
        } else {
            const getUrl = BaseURL + "GainersAndLosers";
            fetch(`${getUrl}/${groupValue}/${groupIndexNSE}/${valueLi}/${valuebtn}/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false)
                    //console.log(getData, "getData")
                })
                .catch((error) => {
                });
        }

        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}/${groupValue}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
                //console.log(getDataGroup, "getDataGroup")
            })
            .catch((error) => {
            });

    }, [groupValue, valuebtn, groupIndex, valueLi, groupIndexNSE]);


    setTimeout(() => {
        eleLi = document.getElementById('liDay');
        eleBtn = document.getElementById('btnGain');
        eleBtnLoose = document.getElementById('btnLoose');
    })

    const routeChange = (event) => {
        const compcocode = event.currentTarget.dataset.id;
        const compcode_array = compcocode.split('-');
        const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '');
        setcocode(compcode_array[1]);
        window.open("/stocks/" + getCoCodeId.toLowerCase(), '_blank');
    };

    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
CallTrackApi("Gainers And Losers",window.location.href);
    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Gainers &amp; Losers</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='gainer-loser-sc'>
                            <div className='gainer-header'>
                                <h2><span>Gainers & Losers</span></h2>
                            </div>
                            <MarketEquity optionInfoMarket={optionInfoMarket} optionTypeComp={optionTypeComp} />
                            <div className='gainer-table-main'>
                                <div className="dropdowndiv">
                                <div className='gainer-loser-toggle'>
                                    <button id="btnGain" value="G" className={(valuebtn === "G") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>Gainers</button>
                                    <button id="btnLoose" value="L" className={(valuebtn === "L") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>Losers</button>
                                </div>
                                <div className='gainer-dates'>
                                    <ul>
                                        <li id="liDay" data-value="Day" className={(valueLi === "Day") ? "active" : ''} onClick={(event) => { setValueLi(event.target.getAttribute("data-value")) }} tabIndex={0}>1D</li>
                                        <li data-value="Week" className={(valueLi === "Week") ? "active" : ''} onClick={(event) => { setValueLi(event.target.getAttribute("data-value")) }}>1W</li>
                                        <li data-value="month" className={(valueLi === "month") ? "active" : ''} onClick={(event) => { setValueLi(event.target.getAttribute("data-value")) }}>1M</li>
                                        <li data-value="3mon" className={(valueLi === "3mon") ? "active" : ''} onClick={(event) => { setValueLi(event.target.getAttribute("data-value")) }}>3M</li>
                                        <li data-value="6mon" className={(valueLi === "6mon") ? "active" : ''} onClick={(event) => { setValueLi(event.target.getAttribute("data-value")) }}>6M</li>
                                        <li data-value="1year" className={(valueLi === "1year") ? "active" : ''} onClick={(event) => { setValueLi(event.target.getAttribute("data-value")) }}>1Y</li>
                                    </ul>
                                </div>
                                <div className='gainer-right'>
                                    <div className='gainer-inner-selectI'>
                                       
                                        {/* aria-label="bse nse" */}
                                        <select aria-label="bse nse" onChange={(event) => { setGroupValue(event.target.value); setGroupIndex("BSE_SENSEX"); setGroupIndexNSE("NIFTY") }}>
                                            <option value="BSE" selected>BSE</option>
                                            <option value="NSE">NSE</option>
                                        </select>
                                    </div>

                                    <div className='gainer-inner-select'>
                                        {(groupValue === "BSE") ?
                                            <select aria-label="bse sensex" onChange={(event) => { setGroupIndex(event.target.value) }}>
                                                {dataGroup && dataGroup.map(({ Group }) => (
                                                    <option value={Group} selected={Group === "BSE_SENSEX"}>{Group}</option>
                                                )
                                                )}
                                            </select> : <select onChange={(event) => { setGroupIndexNSE(event.target.value) }}>
                                                {dataGroup && dataGroup.map(({ Group }) => (
                                                    <option value={Group} selected={Group === "NIFTY"}>{Group}</option>
                                                )
                                                )}
                                            </select>}
                                    </div>
                                </div>
                                </div>
                                {/* <hr className="hrGainerLoser"></hr> */}
                                <div className='gainer-table table-responsive'>
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th className='text-left'>Company Name</th>
                                                <th className='text-right'>LTP(&#8377;)</th>
                                                <th className='text-right'>Change(&#8377;/%)</th>
                                                <th className='text-right'>Prev.Close(&#8377;)</th>
                                                <th className='text-right'>Volume In (No’s)</th>
                                                <th className='text-right'>52 Week H/L(&#8377;)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentTableData && currentTableData.map(
                                                ({ CompLongName, close_price, netchg, perchg, PrevClose, volumeavg, HI_52_WK, LO_52_WK, co_code }) => (
                                                    <tr>
                                                        <td className="text-left"><h6 onClick={routeChange} data-id={CompLongName + '-' + co_code} tabIndex={0} >{CompLongName}</h6></td>
                                                        <td className="text-right"> {(close_price != null) ? close_price.toFixed(2) : 0}</td>
                                                        <td><p className={netchg.toFixed(2) > 0 ? "textGreen text-right" : "textRed text-right"}> {netchg != null ? netchg.toFixed(2) : 0}
                                                            <span className={perchg.toFixed(2) > 0 ? "textGreen text-right" : "textRed text-right"}> {perchg != null ? ("(" + perchg.toFixed(2) + ")") : 0}</span></p></td>
                                                        <td className='text-right'>{(PrevClose != null) ? PrevClose.toFixed(2) : 0}</td>
                                                        <td className='text-right'>{(volumeavg != null) ? volumeavg.toFixed(2) : 0}</td>
                                                        <td><p className="textGreen text-right"> {HI_52_WK != null ? HI_52_WK.toFixed(2) : 0} -
                                                            <span className="textRed text-right"> {LO_52_WK != null ? LO_52_WK.toFixed(2) : 0}</span></p></td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                    {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                                </div>
                                {(data != null && data != []) ?
                                    <Pagination
                                        className="pagination-bar_peer"
                                        currentPage={currentPage}
                                        totalCount={(data.length != null) ? data.length : 0}
                                        pageSize={PageSize}
                                        onPageChange={page => setCurrentPage(page)}
                                    /> : <p className="errorPeer"> No Data Found !!! </p>}
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default GainerLoser;